import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT_BLACK_LIST, GET_BLACK_LIST } from "../../../queries/blackList";

const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT_BLACK_LIST}
      update={(cache, { data: { updateBlackList } }) => {
        const { blackListAll } = cache.readQuery({ query: GET_BLACK_LIST });
        cache.writeQuery({
          query: GET_BLACK_LIST,
          data: { blackList: blackListAll }
        });
      }}
      >
      {updateBlackList => (
        <Form query_f = {updateBlackList} {...props} />
      )}
    </Mutation>
  );
};

export default Update;